module.exports = __webpack_public_path__ + "img/pic_ready.e6693c63.jpg";